import { render, staticRenderFns } from "./OneGroupCheckboxs.vue?vue&type=template&id=7055f995&scoped=true&"
import script from "./OneGroupCheckboxs.vue?vue&type=script&lang=js&"
export * from "./OneGroupCheckboxs.vue?vue&type=script&lang=js&"
import style0 from "./OneGroupCheckboxs.vue?vue&type=style&index=0&id=7055f995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055f995",
  null
  
)

export default component.exports